<div class="max-sessions">
  <div id="alertMessage"
       class="ez-alert warn">
    <mat-icon color="warn">report</mat-icon>

    <div class="error-text">You have reached the maximum number of sessions for your account.</div>
  </div>

  <div>
    <p>You may continue to log in by pressing the "Continue" button below.</p>
    <p>Doing this will log out the session that is currently active.</p>
  </div>

  <div class="buttons">
    <a [href]="cancelHref"
       id="btnLogout"
       color="primary"
       mat-stroked-button>Cancel</a>

    <button type="submit"
            id="btnContinue"
            mat-flat-button
            color="primary">Continue to EZLynx</button>
  </div>
</div>